// 面象分析模块 - face_text 文本映射与合并
// face_text 已在 pipeline.parseBase 中完成 JSON.parse
const FACE_TEXT_MAP = {
    '脸颊发红': '红',
    '眼睑发紫': '紫',
    '唇色发紫': '紫',
    '唇白': '白',
    '唇红': '红',
    '唇色淡红': '淡红'
};

const TARGET_KEYS = ['lian_jia', 'yan_jian', 'chun_zi', 'chun_se'];

const JIANGJIE_JIEGUO_KEYS = ['脸颊', '眼睑', '唇色'];

const FACE_TEXT_MAP_KEYS_SORTED = Object.keys(FACE_TEXT_MAP).sort(
    (a, b) => b.length - a.length
);
const FACE_TEXT_MAP_VALUES = new Set(Object.values(FACE_TEXT_MAP));

/**
 * 将一段 Jieguo 子串洗成规范色名；已是「淡红/紫/红/白」等映射结果的保留原样，避免多段时丢掉「紫」等。
 */
function mapJieguoPart(part) {
    if (!part) return '';
    if (FACE_TEXT_MAP[part] !== undefined) {
        return FACE_TEXT_MAP[part];
    }
    for (const key of FACE_TEXT_MAP_KEYS_SORTED) {
        if (part.includes(key)) {
            return FACE_TEXT_MAP[key];
        }
    }
    if (FACE_TEXT_MAP_VALUES.has(part)) {
        return part;
    }
    return part;
}

/**
 * 「唇色淡红、正常」→「淡红」；「淡红、紫」→「淡红、紫」（逐段清洗后再拼接，不丢段）。
 */
function cleanJieguo(raw) {
    if (raw == null || raw === '') return raw;
    const s = String(raw).trim();
    if (!s) return raw;

    const parts = s
        .split(/[、，,]/)
        .map((p) => p.trim())
        .filter((p) => p && p !== '正常');

    if (parts.length === 0) return s;

    const out = [];
    for (const part of parts) {
        const m = mapJieguoPart(part);
        if (!m) continue;
        if (out.length === 0 || out[out.length - 1] !== m) {
            out.push(m);
        }
    }
    return out.length > 0 ? out.join('、') : s;
}

export default function transform(data) {
    if (!data || !data.face_text) return;
    const ft = data.face_text;

    TARGET_KEYS.forEach((key) => {
        if (ft[key] && FACE_TEXT_MAP[ft[key]]) {
            ft[key] = FACE_TEXT_MAP[ft[key]];
        }
    });

    if (ft.jiangjie && typeof ft.jiangjie === 'object') {
        JIANGJIE_JIEGUO_KEYS.forEach((name) => {
            const item = ft.jiangjie[name];
            if (item && item.Jieguo != null) {
                item.Jieguo = cleanJieguo(item.Jieguo);
            }
        });
    }

    if (ft.chun_zi === '紫' && ft.chun_se) {
        ft.chun_se = ft.chun_se + '、紫';
    }
    //ft.chun_zi = '';
}
